import React, { useState } from 'react';
import ReportedSoldList from './components/ReportedSoldList';
import ActionBar from '../layout/ActionBar';
import UploadSold from './slideout/UploadSold';
import SlidingPane from 'react-sliding-pane';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';

function ReportedSold() {
  usePageTitle(['Reported sold', 'Keys']);
  const [reload, setReload] = useState<any>();
  const [uploadKeysSlideoutOpen, setUploadKeysSlideoutOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setUploadKeysSlideoutOpen(true)}
          text={t('Upload sold keys')}
        />
      </ActionBar>
      <ReportedSoldList reload={reload} />
      <SlidingPane
        isOpen={uploadKeysSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => {
          setUploadKeysSlideoutOpen(false);
          setReload(new Date());
        }}
      >
        <UploadSold
          done={() => {
            setUploadKeysSlideoutOpen(false);
            setReload(new Date());
          }}
          cancel={() => setUploadKeysSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default ReportedSold;
